import { transport } from 'config/transport';

export function callApiExportMamNonReportForAllCongDoan(academicYear) {
    return transport.get(`/trunguong/report/mamnon/annually`, { params: { academicYear }, responseType: 'blob' });
}
